module.exports = __webpack_public_path__ + "static/media/peds-book@3x.0ddafae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peds-book@3x.png
// module id = 1731
// module chunks = 0